import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { InputTextModule } from 'primeng/inputtext'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { Page } from 'app/_shared/interfaces/config'
import { DesignerService } from 'app/_shared/services/designer.service'
import { AppConfigService } from 'app/app-config.service'
import { ConfigStore } from 'app/store/config.store'

@Component({
  selector: 'app-text-editor',
  imports: [InputTextModule, TranslatePipe, FormsModule, ButtonComponent],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordComponent {
  designerService = inject(DesignerService)
  configStore = inject(ConfigStore)
  appConfigService = inject(AppConfigService)

  page = input.required<Page>()

  error = signal('')

  password = ''
  storefrontId = this.appConfigService.getAppConfig?.id

  submitPassword() {
    this.error.set('')
    this.designerService
      .checkPagePassword(this.storefrontId, { password: this.password, page_id: this.page().id })
      .subscribe({
        next: () => {
          this.configStore.updatePage({ ...this.page(), allowedAccess: true })
        },
        error: () => {
          this.error.set('Password is incorrect. Please try again.')
        }
      })
  }
}
